import { fetchAuthSession } from 'aws-amplify/auth';
import axios, { type AxiosError, type InternalAxiosRequestConfig } from 'axios';

const apiClient = axios.create({
    baseURL: import.meta.env.VITE_ADMIN_API_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

apiClient.interceptors.request.use(
    async (config: InternalAxiosRequestConfig) => {
        try {
            const session = await fetchAuthSession();
            const accessToken = session.tokens?.accessToken;

            if (accessToken) {
                config.headers.Authorization = accessToken.toString();
            }
        } catch (error) {
            console.error('Failed to fetch auth session:', error);
        }

        return config;
    },
    (error: AxiosError) => {
        return Promise.reject(error);
    },
);

apiClient.interceptors.response.use(
    (response) => response,
    (error: AxiosError<{ message?: string }>) => {
        if (error.response) {
            const { status, data } = error.response;

            if (status === 401) {
                window.location.href = '/login';
            }

            let errorMessage = 'An error occurred';
            if (data.message) {
                errorMessage = data.message;
            } else if (error.message) {
                errorMessage = error.message;
            }
            const enhancedError = Object.assign(new Error(errorMessage), {
                response: { status, data },
            });
            return Promise.reject(enhancedError);
        }

        if (error.request) {
            return Promise.reject(new Error('Network error - please check your connection'));
        }

        return Promise.reject(error);
    },
);

export default apiClient;
